// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__d0634f2453c6be85e30f","cls2":"SimplePaperPodcast-cls2___8f171627a56237c39d5 SimplePaperPodcast-cls1__d0634f2453c6be85e30f"};